import React from 'react';
import classnames from 'classnames';
import { IMAGE_SIZE } from '@zmedia/bm-soccer-ui/constants';
import Element from '../../element';
import styles from './card.module.scss';

interface IProps {
    className?: string;
    children?: React.ReactNode;
    rounded?: boolean;
    size?: IMAGE_SIZE;
}

export default function CardImage({
    className,
    children,
    rounded = false,
    size = '',
    ...rest
}: IProps) {
    return (
        <Element
            className={classnames(styles['bm-card-image'], className, {
                [styles['is-rounded']]: rounded,
                [styles[`is-${size}`]]: size,
            })}
            {...rest}
        >
            {children}
        </Element>
    );
}
